import GLightbox from 'glightbox';
import '../../node_modules/glightbox/dist/css/glightbox.min.css';

const glightbox = GLightbox({
    touchNavigation: true,
});

